import type { ReactNode } from 'react';
import { DEFAULT_FORM_HEIGHT } from './constants';
import style from './Form.module.scss';
type Props = {
  children?: ReactNode;
  formHeight?: number;
};
export default function FormSkeleton({
  children,
  formHeight = DEFAULT_FORM_HEIGHT
}: Props) {
  return <aside data-testid="Aside" className={style.skeleton} style={{
    minHeight: `${formHeight}px`
  }} aria-hidden={children ? undefined : true} data-sentry-component="FormSkeleton" data-sentry-source-file="FormSkeleton.tsx">
			{children}
		</aside>;
}